import BaseModel from '../base';

import constants from './constants';
import glossary from './glossary';

export default class Estimate extends BaseModel {
  constructor(estimate = {}, url) {
    super(estimate, url);

    this.expert_id = estimate.expert_id;
    this.journal_id = estimate.journal_id;
    this.status = estimate.status;
  }

  get displayStatus() {
    const { status } = this;
    const statusData = this.constructor.glossary.ESTIMATE_STATUSES_DATA[status];

    return {
      ...statusData,
      isNew: this.constructor.constants.ESTIMATE_STATUSES.NEW === status,
      isFinished: this.constructor.constants.ESTIMATE_STATUSES.FINISH === status,
    };
  }

  static get constants() {
    return constants;
  }

  static get glossary() {
    return glossary;
  }
}
